import { useState } from 'react'
import { useAuth } from '@/contexts/AuthContext'
export function PlatformMfaRenewal() {
  const { renewPlatformMfa } = useAuth()
  const [code, setCode] = useState(''), [busy, setBusy] = useState(false), [message, setMessage] = useState('')
  return <section className="card p-5 space-y-3" aria-label="Renew reviewer MFA">
    <h2 className="font-semibold">Renew reviewer MFA</h2>
    <p>Use a current authenticator or recovery code, then check or retry the saved original preparation. Renewal does not submit a review or create another command.</p>
    <label>Authenticator or recovery code<input className="input w-full" type="password" autoComplete="one-time-code" maxLength={16} value={code} onChange={e => setCode(e.target.value)} disabled={busy} /></label>
    <button className="btn" disabled={busy || !code.trim() || !renewPlatformMfa} onClick={async () => {
      setBusy(true); setMessage('')
      try { await renewPlatformMfa!(code); setMessage('Reviewer MFA renewed. Use the saved original command for recovery.') }
      catch { setMessage('MFA renewal unavailable. Check the code,current session and any verification lockout. Keep original command references.') }
      finally { setCode(''); setBusy(false) }
    }}>Renew MFA for this session</button>
    {message && <p role="status">{message}</p>}
  </section>
}
